/**
 * Created by sung on 2017-02-07.
 */

// angular api / primeng module
import {NgModule, Component, OnInit} from '@angular/core';
import { DataTableModule, PanelModule, CalendarModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule, ButtonModule, PickListModule } from 'primeng/primeng';
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import {CommonModule, DatePipe} from "@angular/common";
import {Calendar} from "primeng/components/calendar/calendar";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

// custom module
import {UserGroupCheckTreeModule} from "../../component/user_checktree.component";
import {MamAdminService} from '../../service/mam_service.component';
import {SearchModule} from "../../component/search.component";
import {AttributeGroupTreeModule} from "../../component/attribute-group-tree/attribute-group-tree.component";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {Notice} from "../../model/notice";
import {SelectItem} from "primeng/components/common/api";
import { ExDialogModule } from  '../../component/dialog.component';
import { NoticeModel } from '../../model/noticeModel';
import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service";


@Component({
  selector:'notice-management',
  templateUrl:'notice_management.html'
})
export class NoticeManagementComponent implements OnInit {

  totalRecord: number;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  sDate: string;
  eDate: string;

  searchText: string;
  searchId : string;
  pageMax:number =10;

  notice_title : string;
  notice_content : string;
  notice_sDate : string;
  notice_eDate : string;
  notice_target : string;

  current_select_id : number;

  // 팝업
  addShow : boolean = false;
  add_targets : boolean = false;
  addForm : FormGroup;
  submitted: boolean;
  title : any = "";
  dialogWidth : any = 600;
  addTargetWidth : any = 1000;

  company_items : SelectItem[];
  selectedCompany : ThirdPartyCompany;

  // attribute target id
  targetIds : any[] = [];

  translate : TranslateServiceForm;
  private company_list : ThirdPartyCompany[] = [];

  constructor(private service : MamAdminService, private fb: FormBuilder, private logger : Logger, private _translate: TranslateServiceForm) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 0});
    this.searchIDs.push({label: this.translate.instant('NoticeSubject'), value: 1});
    this.searchIDs.push({label: this.translate.instant('NoticeContent'), value: 2});

    this.company_items = [];
    this.company_items.push({label : '--------------', value : ''});

    this.dateIsTrue = false;

    this.addForm = this.fb.group({
      'name' : new FormControl('',Validators.required),
      'company' : new FormControl('',Validators.required),
      'content' : new FormControl('',Validators.required),
      'startDate' : new FormControl('', Validators.required),
      'endDate' : new FormControl('', Validators.required)
    });
  }

  ngOnInit() {
    this.getNoticeList(0,10,"","");
    this.getCompanyList();
  }

  getSearchModel(event){
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;
    this.getNoticeList(0,this.pageMax,this.searchText, this.searchId);
  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      this.getNoticeList(event.page, event.rows,this.searchText,  this.searchId);
    } else {
      this.getNoticeList(event.page, event.rows, '',"");
    }

  }

  getCompanyList() {
    this.service.getCompanyAdminList().subscribe(
        value => {
          this.logger.debug("-- company_list :", value);
          this.company_list = value;
        },
        error => { this.logger.error("-- error : " + error);},
        () => {
          if(this.company_list.length > 0) {
            this.company_list.forEach(company => {
              this.company_items.push({label:company.name, value:company});
            });
          }
        }
    )
  }

  getNoticeList(page:number, max:number, search:string, field:string) {
    this.service.getNoticeList(page, max, search, field).subscribe(
        value => {
          this.logger.debug("-- notice_list :", value);
          this.table_list = value.content;
          this.totalRecord = value.totalElements;

        },
        error => { this.logger.error("-- error : " + error);},
        () => {}
      )
  }

  insertNotice(notice:NoticeModel){
    this.service.insertNotice(notice).subscribe(
        value => {
          this.table_list = value.rows;
          this.totalRecord = value.total;
          //this.logger.debug("-- notice_list :", value);
        },
        error => {this.logger.error("-- error : " + error);},
        () => {
          this.getNoticeList(0,10,'','');
        }
      )
  }

  deleteNotice(id:number){
    this.service.deleteNotice(id).subscribe(
        value => {
          this.getNoticeList(0,10,'','');
          let result = value;

        },
        error => {this.logger.error("-- error : " + error);},
        () => {}
      )
  }

  addNoticeTarget(attr_id : any, notice_id : number) {
    this.service.addNoticeTarget(attr_id, notice_id).subscribe(
        value => {
          this.logger.debug("result  " , value);
        },
        error => {},
        () => {}
      )
  }

  deleteNoticeTarget(attr_id : any, notice_id : number) {
    this.service.deleteNoticeTarget(attr_id, notice_id).subscribe(
      value => {

      },
      error => {},
      () => {}
    )
  }

  add_notice(event){
    this.logger.debug("event :" ,event);
    // this.company_items = [];

    if(this.company_list.length > 0) {
      this.selectedCompany = this.company_list[0];
    }
    this.addShow = true;
    this.title = this.translate.instant('LANG_Notice') + " "+this.translate.instant('BUTTON_ADD');
  }

  onRowSelect(event) {
    this.current_select_id = event.data.id;
  }

  delete_notice(event) {
    this.deleteNotice(this.current_select_id);
  }

  onChange(event) {
    this.logger.debug("onchage :");
  }

  addTargetClick(event) {
    this.add_targets = true;
  }

  onSelectedCompany(event) {
    this.selectedCompany = event;
  }

  selectedTrees(attr) {
    this.targetIds = [];
    this.logger.debug("select attribute data :", attr);
    attr.forEach(attribute => {
      this.targetIds.push(attribute.id);
    })
  }

  sendNotice(notice) {
    if(this.targetIds.length == 0) {
      alert(this.translate.instant('MESSAGE_Select_Property_LeftTree'));
      return;
    }
    this.logger.debug("send notice :", notice);
    this.logger.debug("send attribute : ", this.targetIds);
    this.addNoticeTarget(this.targetIds, notice.id);
  }

  sendDeleteTarget(notice) {
    if(this.targetIds.length == 0) {
      alert(this.translate.instant('MESSAGE_Select_Property_LeftTree'));
      return;
    }
    this.logger.debug("send notice :", notice);
    this.logger.debug("send attribute : ", this.targetIds);
    this.deleteNoticeTarget(this.targetIds, notice.id);
  }


  onSubmit(event) {
    this.logger.debug(this.selectedCompany);
    this.logger.debug("form data :", event);
    let datePipe = new DatePipe("en");
    let sDate = datePipe.transform(event.startDate, 'yyyy-MM-dd');
    let eDate = datePipe.transform(event.endDate, 'yyyy-MM-dd');
    let notice = {id : null, name : event.name, content : event.content, startDate:sDate, endDate:eDate, company:this.selectedCompany};
    this.insertNotice(notice);
    this.addShow = false;
    this.addForm.reset();
  }
  cancel(){
    this.addShow = false;
  }



}

@NgModule({
  imports:[DataTableModule, SharedModule, PanelModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule,FormsModule,SearchModule, ButtonModule, ExDialogModule, ReactiveFormsModule, CalendarModule, PickListModule, UserGroupCheckTreeModule, AttributeGroupTreeModule, CompanyDropDownListModule, UserGroupCheckTreeModule, TranslatePipeMoudle],
  declarations:[NoticeManagementComponent],
  exports:[NoticeManagementComponent],
  providers:[MamAdminService]
})
export class NoticeManagementModule{

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/system/notice_management.ts